import { Component } from '@angular/core';
import { OrderEditingService } from '@app/pages/order-editing/order-editing.service';
import { OrderEditing } from '@pdqdev/pdq-shared/dist/interfaces';
@Component({
  selector: 'order-editing-form-repricing',
  standalone: false,
  templateUrl: './order-editing-form-repricing.component.html',
  styleUrl: './order-editing-form-repricing.component.scss',
})
export class OrderEditingFormRepricingComponent {
  taxAdjustmentTypeOptions = [
    { value: OrderEditing.TaxAdjustmentType.NO_ADJUSTMENT, text: 'Allow Edits Without Charging Extra' },
    { value: OrderEditing.TaxAdjustmentType.BLOCK_EDITS_WHEN_AFFECTED, text: 'Block Edits That Affect Taxes' },
    { value: OrderEditing.TaxAdjustmentType.RECALCULATE, text: 'Always Recalculate & Adjust Tax' },
  ];

  UnpaidChangesHandlingType = OrderEditing.UnpaidChangesHandlingType;
  FulfillmentHoldReleaseMode = OrderEditing.FulfillmentHoldReleaseMode;
  constructor(public orderEditingService: OrderEditingService) {}
}
